import PropTypes from "prop-types";

export const CoachBillingReport = ({ report, isCurrentMonth, plan }) => {
  const { athletes = [], reportedAmount } = report;
  const { amount: planAmount } = plan;
  return (
    <>
      <section role="table-wrapper" data-borders-inside data-scrollable>
        <table role="report-table">
          <thead className="labels">
            <tr>
              <th className="name">Athlete</th>
              <th className="email">Email</th>
              <th className="amount">Total days</th>
            </tr>
          </thead>
          <tbody>
            {athletes.length > 0 &&
              athletes.map((athlete) => {
                const {
                  athleteName,
                  athleteEmail,
                  amount: athleteAmount,
                  athleteId,
                } = athlete;
                return (
                  <tr className="report" key={String(athleteId)}>
                    <td className="name">{athleteName}</td>
                    <td className="email">{athleteEmail}</td>
                    <td className="amount">
                      {Number(athleteAmount).toFixed(0)}
                    </td>
                  </tr>
                );
              })}
          </tbody>
        </table>
      </section>

      <div className="total">
        <div className="totalValue">
          {isCurrentMonth && <span>Estimated </span>}
          Total:{" "}
          <span className="clipped font-semibold">
            ${Number((reportedAmount * planAmount) / 100).toFixed(2)}
          </span>
        </div>
      </div>
    </>
  );
};

CoachBillingReport.contextTypes = {
  report: PropTypes.object,
  isCurrentMonth: PropTypes.number,
  plan: PropTypes.object,
};
